import React, { useState, useRef } from 'react';
import { useNavigate } from "react-router-dom";
import Icon0 from '../../../local-assets/faq-v2/Icon-0.png';
import Icon1 from '../../../local-assets/faq-v2/Icon-1.png';
import Icon2 from '../../../local-assets/faq-v2/Icon-2.png';
import Icon3 from '../../../local-assets/faq-v2/Icon-3.png';
import Icon4 from '../../../local-assets/faq-v2/Icon-4.png';
import Icon5 from '../../../local-assets/faq-v2/Icon-5.png';
import Icon6 from '../../../local-assets/faq-v2/Icon-6.png';
import Icon7 from '../../../local-assets/faq-v2/Icon-7.png';
import Icon8 from '../../../local-assets/faq-v2/Icon-8.png';
import Icon9 from '../../../local-assets/faq-v2/Icon-9.png';
import Icon10 from '../../../local-assets/faq-v2/Icon-10.png';
import { Link } from 'react-router-dom';

const Topic = () => {
  const navigate = useNavigate();
  const [activeIndex, setActiveIndex] = useState(0);
  const scrollRef = useRef(null);

  // Memasukkan semua data ke dalam array agar kode lebih rapi dan dinamis
  const faqList = [
    { icon: Icon0, subTitle: "Summarecon Mall & Home", title: "Mengapa registrasi di summarecon apps memerlukan foto KTP dan foto Selfie?", routePath: "v2/faq/register-ktp" },
    // { icon: Icon1, subTitle: "Summarecon Mall & Home", title: "Property saya ter-take out, apa yang harus saya lakukan?", routePath: "v2/faq" },
    { icon: Icon2, subTitle: "Summarecon Mall & Home", title: "Mengapa jumlah lot saat book reserve parking di apps dan di lapangan berbeda?", routePath: "v2/faq/lot-reserve-parking" },
    { icon: Icon3, subTitle: "Summarecon Mall & Home", title: "Saya turun ke green, apa bedanya dengan gold member?", routePath: "v2/faq/down-to-green" },
    { icon: Icon4, subTitle: "Summarecon Mall & Home", title: "Kenapa struk saya ditolak & bagaimana mengatasinya?", routePath: "v2/faq/struk-reject" },
    { icon: Icon5, subTitle: "Summarecon Mall & Home", title: "Bagaimana cara bayar tagihan di home apps?", routePath: "v2/faq/payment" },
    { icon: Icon6, subTitle: "Summarecon Mall & Home", title: "Bagaimana cara upload struk yang benar?", routePath: "v2/faq/struk-approve" },
    // { icon: Icon7, subTitle: "Summarecon Home", title: "Bagaimana cara daftar dan claim property?", routePath: "v2/faq" },
    { icon: Icon8, subTitle: "Summarecon Mall & Home", title: "Bagaimana cara mengetahui tanggal kedaluwarsa stamp saya?", routePath: "v2/faq/expired-stamp"  },
    { icon: Icon9, subTitle: "Summarecon Home", title: "Apa keuntungan mengajukan izin & laporan di Summarecon Home Apps", routePath: "v2/faq/permit-report" },
    // { icon: Icon10, subTitle: "Summarecon Mall & Home", title: "Stamp dan cara mengumpulkannya", routePath: "v2/faq" },
    { icon: Icon0, subTitle: "Summarecon Mall & Home", title: "Kenapa validasi KTP saya ditolak & bagaimana cara mengatasinya ?", routePath: "v2/faq/validasi-ktp" },
    { icon: Icon1, subTitle: "Summarecon Home", title: "Kenapa saya tidak bisa mengakses kembali properti saya ?", routePath: "v2/faq/access-property" }
  ];

  const totalColumns = Math.ceil(faqList.length / 3);
  const handleScroll = () => {
    if (scrollRef.current) {
      const { scrollLeft, clientWidth } = scrollRef.current;
      const columnWidth = clientWidth * 0.9;
      const newIndex = Math.round(scrollLeft / columnWidth);
      setActiveIndex(newIndex);
    }
  };

  return (
    <section className="bg-[#F8F9FA] py-12 md:py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

        <nav className="flex items-center gap-2 md:gap-3 text-sm md:text-base font-medium text-[#475467] mb-5">
          <Link to="/" className="hover:text-[#F36F21] transition-colors flex items-center">
            <svg className="w-5 h-5 md:w-6 md:h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"></path>
            </svg>
          </Link>
          <svg className="w-4 h-4 text-gray-300" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7"></path>
          </svg>
          <span className="transition-colors font-semibold">
            FAQ
          </span>
        </nav>
        
        <h3 className="text-xl md:text-2xl font-bold text-[#101828] mb-6 md:mb-8 py-4 ">
          Topik paling dicari
        </h3>

        {/* 4. Tambahkan ref={scrollRef} dan onScroll={handleScroll} ke container ini */}
        <div 
          ref={scrollRef}
          onScroll={handleScroll}
          className="grid grid-rows-3 grid-flow-col auto-cols-[90%] md:auto-cols-auto md:grid-rows-none md:grid-flow-row md:grid-cols-2 gap-3 md:gap-4 overflow-x-auto md:overflow-visible snap-x snap-mandatory pb-2 md:pb-0 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden"
        >
          {faqList.map((item, index) => (
            <div 
              key={index}
              onClick={() => navigate(`/${item.routePath}`)}
              className="snap-start bg-white border border-gray-200 rounded-xl p-4 flex flex-row items-center cursor-pointer hover:border-[#F36F21] hover:shadow-md transition-all group h-full"
            >
              <div className="mr-4 flex-shrink-0">
                <img src={item.icon} alt="FAQ Icon" className="w-12 h-12 md:w-16 md:h-16 object-contain" />
              </div>
              
              <div className="flex-1">
                <p className="text-xs md:text-sm text-[#475467] mb-0.5 font-medium">
                  {item.subTitle}
                </p>
                <h4 className="text-sm md:text-base font-semibold text-[#101828] leading-snug">
                  {item.title}
                </h4>
              </div>
              
              <div className="ml-3 text-gray-300 font-bold text-xl group-hover:text-[#F36F21] transition-colors flex-shrink-0">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M9 18l6-6-6-6" />
                </svg>
              </div>
            </div>
          ))}
        </div>

        {/* 5. INDIKATOR DOTS */}
        {/* Hanya dimunculkan di mobile (md:hidden) karena desktop tidak pakai slider */}
        <div className="flex justify-center items-center gap-2 mt-6 md:hidden">
          {Array.from({ length: totalColumns }).map((_, idx) => (
            <div
              key={idx}
              className={`h-2 rounded-full transition-all duration-300 ${
                activeIndex === idx 
                  ? 'w-6 bg-[#F36F21]' // Dot aktif: melebar dan warna oranye
                  : 'w-2 bg-gray-300'  // Dot pasif: bulat kecil dan warna abu-abu
              }`}
            />
          ))}
        </div>

      </div>
    </section>
  );
};

export default Topic;